import config from '../../config';
import { makeAPICall, APIError, redirectTo, getCurrentOrgIdByContext } from '../generalCreators';
import { getCurrentOrganisationShapeSets } from '../organisations/shapeSetCreators';
import { getCurrentLocationShapeSets } from '../locations/shapeSetCreators';
import { updateCurrentShapeSet } from './currentShapeSetCreators';

export function getGlobalShapeSets(excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/shapesets';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => dispatch(updateGlobalShapeSets(response.data.shapeSets)),
      error => dispatch(APIError(error, 'Error getting ShapeSets'))
    );
  };
}

export function updateGlobalShapeSets(shapeSets) {
  return {
    type: 'UPDATE_GLOBAL_SHAPESETS',
    shapeSets
  }
}

export function getShapeSet(shapeSetId, context = undefined, withSettings = true ) {
  return function(dispatch, getState) {
    const organisationId = getCurrentOrgIdByContext(context, getState);
    const endpoint = `/shapeset/${shapeSetId}`;
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        withSettings
      }
    };

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const shapeSetWithSettings = response.data;
        return shapeSetWithSettings;
      },
      error => dispatch(APIError(error, 'Error getting ShapeSet'))
    );
  };
}

export function addShapeSet(shapeSet, context = 'global') {
  return function(dispatch, getState) {
    const organisationId = getCurrentOrgIdByContext(context, getState);
    const endpoint = '/shapesets';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: shapeSet
    };

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const newShapeSetId = response.data.id;
        switch (context) {
          default:
          case 'global':
            dispatch(getGlobalShapeSets());
            break;
          case 'customer':
            dispatch(getCurrentOrganisationShapeSets(organisationId));
            break;
          case 'sub-account':
            dispatch(getCurrentLocationShapeSets(organisationId))
            break;
        };
        dispatch(updateCurrentShapeSet(newShapeSetId, context));

        const newShapeSetUrl = `/${context}/${organisationId}/catchment-sets/${newShapeSetId}`;

        redirectTo(newShapeSetUrl);
        return response;
      },
      error => dispatch(APIError(error, 'Error creating ShapeSet'))
    );
  };
}

export function updateShapeSet(shapeSet, context = 'global') {
  return function(dispatch, getState) {
    const organisationId = getCurrentOrgIdByContext(context, getState);
    const endpoint = `/shapeset/${shapeSet.id}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: shapeSet
    };

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        let organisationId = undefined;
        switch (context) {
          default:
          case 'global':
            dispatch(getGlobalShapeSets());
            break;
          case 'customer':
            organisationId = getState().currentOrganisation.id;
            dispatch(getCurrentOrganisationShapeSets(organisationId));
            break;
          case 'sub-account':
            organisationId = getState().currentLocation.id;
            dispatch(getCurrentLocationShapeSets(organisationId))
            break;
        };
        dispatch(updateCurrentShapeSet(shapeSet.id, context));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating ShapeSet'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/shapeSets/basicCreators.js